import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

import {Id, Info} from './Product.style';

export const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 100%;
  height: 25.8rem;
  max-height: 25.8rem;
  padding-bottom: 1rem;
  margin: 0.8rem;
  flex-direction: column;
  background-color: ${p => p.theme.tertiaryBgColor};
  display: flex;
  ${media.medium`
    height: 25.8rem;
    max-height: 25.8rem;
  `};
  ${media.small`
    height: 21.5rem;
    max-height: 21.5rem;
  `}
  ${media.smaller`
    margin: 0.8rem 0.4rem;
  `};
  ${media.smallest`
    margin: 0 0 1rem;
  `};
`;

export const ListViewContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;

export const Price = styled.div`
  color: ${p => p.theme.tertiaryTextColor};
  font-size: 1.4rem;
  ${media.small`
    font-size: 1.2rem;
  `};
`;

export const Larger = styled.span`
  font-size: 1.6rem;
  ${media.small`
    font-size: 1.4rem;
  `};
`;

export const Content = styled.div`
  flex-grow: 1;
  padding: 0 2rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${media.medium`
    padding: 0 1rem 1rem;
  `};
`;

export const Weight = styled.span`
  font-size: 1rem;
  text-align: right;
  width: 100%;
  color: ${p =>
    p.$isOffer ? p.theme.tertiaryColor : p.theme.tertiaryTextColor};
  line-height: 1.8rem;
  padding-top: 0.4rem;
  ${media.small`
    margin-top: 0;
  `};
`;

export const PhotoWrapper = styled.div`
  position: relative;
  width: 17rem;
  height: 17rem;
  text-align: center;
  margin: 0 1rem 0 2rem;
  cursor: pointer;
  ${media.small`
    width: 15rem;
    height: 15rem;
    margin: 0 0 0 1rem;
  `};
  ${media.smallest`
    display: flex;
    align-items: center;
  `};

  img {
    width: 17rem;
    height: 17rem;
    min-height: 17rem;
    min-width: 17rem;
    z-index: 1;
    ${media.small`
      width: 15rem;
      height: 15rem;
      min-width: 15rem;
      min-height: 15rem;
      max-height: 15rem;
    `};
    ${media.smallest`
      margin-left: 0;
    `};
  }
`;

export const ListViewInfo = styled(Info)`
  padding-left: 0;
  margin-bottom: 0.5rem;
  text-align: left;
  ${media.medium`
    margin-bottom: 0;
  `};
`;

export const NameWrapper = styled.div`
  width: 100%;
  ${media.small`
    padding: 0;
  `};
`;
export const Name = styled.h3`
  display: block;
  font-size: 1.5rem;
  font-weight: normal;
  margin: 0;
  text-overflow: ellipsis;
  min-height: 2rem;
  max-height: 2rem;
  text-align: left;
  color: ${p => p.theme.tertiaryTextColor};
  cursor: pointer;
  overflow: hidden;
  ${media.medium`
    font-size: 1.2rem;
    min-height: 3rem;
    max-height: 3rem;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  `};
  ${media.small`
    min-height: 3.2rem;
    max-height: 3.2rem;
  `};
`;

export const ButtonStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  font-size: 1.4rem;
  padding: 1rem 0;

  a {
    width: 50%;
  }

  ${media.medium`
    padding: 0;
  `};
  ${media.small`
    a {
      width: 100%;
    }
  `};
  ${media.smaller`
    font-size: 1.2rem;
  `};
`;

export const Details = styled(Content)`
  padding: 0;
  width: 40%;
  flex-direction: column;
  text-align: center;
  ${media.medium`
    padding: 0;
  `};
  ${media.small`
    width: 60%;
  `};
  ${media.smallest`
    width: 75%;
  `};
`;

export const PriceWrapper = styled.div`
  width: 100%;
  font-size: 1.4rem;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  ${media.small`
    padding: 0.5rem 0;
    line-height: 1.4rem;
  `};
  ${media.smallest`
    padding: 1rem 0;
  `};
`;

export const Description = styled.span`
  display: block;
  font-size: 1.3rem;
  color: ${p => p.theme.textColor};
  line-height: 2rem;
  max-height: 4rem;
  height: 4rem;
  width: 100%;
  max-width: 100%;
  word-wrap: break-word;
  text-overflow: ellipsis;
  text-align: left;
  cursor: pointer;
  overflow: hidden;
  ${media.medium`
    font-size: 1.2rem;
    line-height: 1.3rem;
    margin-top: 0;
  `};
  ${media.small`
    line-height: 1.2rem;
    display: none;
  `};
`;

export const PromoWrapper = styled.div`
  text-align: center;
  width: 100%;
  height: 2rem;
  min-height: 2rem;
  max-height: 2rem;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${media.smaller`
    height: 1.6rem;
    flex-direction: column;
    min-height: 2.6rem;
    max-height: 2.6rem;
  `};
  ${media.smallest`
    align-items: flex-start;
    flex-direction: column;
    height: 2.2rem;
    min-height: 2.2rem;
    max-height: 2.2rem;
  `};
`;

export const SubWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const TagsWrapper = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  bottom: -1rem;
  ${media.small`
    position: relative;
  `};
`;

export const ListId = styled(Id)`
  font-size: 1.6rem;
  line-height: 4rem;
  ${media.medium`
    font-size: 1.4rem;
  `};
  ${media.smaller`
    padding-left: 0;
  `}
`;

export const ExtraPromo = styled.div`
  color: ${p => p.theme.tertiaryColor};
  font-size: 1.6rem;
  width: 100%;
  text-align: left;
  text-transform: uppercase;
  height: 3.2rem;
  ${media.medium`
   font-size: 1.4rem;
  `};
`;

export const SmallExtraPromo = styled(ExtraPromo)`
  font-size: 1.4rem;
  ${media.medium`
   font-size: 1.3rem;
  `};
`;

export const PriceWholeWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding-bottom: 0.4rem;
  margin-top: ${p => (p.$hasNoOffers ? '2rem' : 0)};
`;

export const SmallPriceWholeWrapper = styled(PriceWholeWrapper)`
  margin-top: ${p => (p.$hasNoOffers ? '3.3rem' : 0)};
`;

export const PriceText = styled.div`
  font-size: 1.8rem;
  text-align: ${p => (p.$alignRight ? 'right' : 'left')};
  color: ${p =>
    p.$isOffer ? p.theme.tertiaryColor : p.theme.tertiaryTextColor};
  margin: ${p => (p.$hasNoOffers ? '0.5rem 0' : 0)};
  ${media.medium`
   font-size: 1.6rem;
  `};
`;

export const QtyWrapper = styled.div`
  width: 50%;
  ${media.smaller`
    width: 100%;
  `}
`;

export const PriceUnavailable = styled.div`
  height: 6.5rem;
  display: flex;
  align-items: center;
`;
